import React, { useEffect } from 'react'
import scrollIntoView from 'scroll-into-view'

import Dropdown from 'components/base/Dropdown'

const PopularNamesDropDownItem = ({ isHighlighted, onClick, children }) => {
  const itemRef = React.useRef()
  useEffect(
    () => {
      if (isHighlighted) {
        scrollIntoView(itemRef.current, { time: 0, behavior: 'smooth' })
      }
    },
    [isHighlighted]
  )
  return (
    <Dropdown.Item
      ref={itemRef}
      className="no-outline"
      onClick={onClick}
      selected={isHighlighted}
    >
      {children}
    </Dropdown.Item>
  )
}

export default PopularNamesDropDownItem
